import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'notificationContentParser',
  standalone: false,
})
export class NotificationContentParserPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  public transform(value: string): unknown {
    const parser = new DOMParser();
    const doc = parser.parseFromString(value, 'text/html');
    const anchorElements = doc.querySelectorAll('a[data-src]');

    anchorElements.forEach((element: Element) => {
      const dataSrc = element.getAttribute('data-src');

      if (dataSrc) {
        const keys = dataSrc.split(' ');
        const investmentId = (keys.find(key => key.includes('portfolioId')) ?? '').split(':')[1];
        const blogArticleId = (keys.find(key => key.includes('blogId')) ?? '').split(':')[1];
        const draftPortfolioId = (keys.find(key => key.includes('draftPortfolioId')) ?? '').split(':')[1];

        if(!investmentId && !blogArticleId && !draftPortfolioId) {
          console.error('Unknown HTML parsing attribut. Expected "portfolioId:number" or "blog:number" or "draftPortfolioId:number" received: ', dataSrc)
        }

        element.setAttribute('style', 'text-decoration: underline;cursor: pointer;color: #858585;')

        if(blogArticleId) {
          element.setAttribute('href', '/blog/' + blogArticleId);
        }
        else if (draftPortfolioId) {
          element.setAttribute('href', '/draft-investment/detail/' + draftPortfolioId);
        } else {
          // TODO: ask how to handle in redesign
          if(keys.includes('transaction')) {
            //element.setAttribute('href', '/money/' + investmentId);
            element.setAttribute('href', '/money');
          } else {
            element.setAttribute('href', '/investment-detail/' + investmentId);
          }
        }
      }
    });

    const modifiedHtml = new XMLSerializer().serializeToString(doc);

    return this.sanitizer.bypassSecurityTrustHtml(modifiedHtml);
  }
}
